import React from 'react'
import { MDBBtn, MDBCol, MDBInput, MDBRow } from 'mdbreact'

const OpcionesBoton = (props) => {
    const { type, id, handleEstilosComponente, styles } = props;

    return (
        <>
            <div>
                <h6>Colores</h6>
                <MDBBtn className='btn-colores-opciones' color="primary" onClick={(e) => handleEstilosComponente({ type, id, valor: "primary", nombre: 'color' })} />
                <MDBBtn className='btn-colores-opciones' color="secondary" onClick={(e) => handleEstilosComponente({ type, id, valor: "secondary", nombre: 'color' })} />
                <MDBBtn className='btn-colores-opciones' color="success" onClick={(e) => handleEstilosComponente({ type, id, valor: "success", nombre: 'color' })} />
                <MDBBtn className='btn-colores-opciones' color="info" onClick={(e) => handleEstilosComponente({ type, id, valor: "info", nombre: 'color' })} />
                <MDBBtn className='btn-colores-opciones' color="warning" onClick={(e) => handleEstilosComponente({ type, id, valor: "warning", nombre: 'color' })} />
                <MDBBtn className='btn-colores-opciones' color="danger" onClick={(e) => handleEstilosComponente({ type, id, valor: "danger", nombre: 'color' })} />
                <MDBBtn className='btn-colores-opciones' color="black" onClick={(e) => handleEstilosComponente({ type, id, valor: "black", nombre: 'color' })} />
                <MDBBtn className='btn-colores-opciones' color="unique" onClick={(e) => handleEstilosComponente({ type, id, valor: "unique", nombre: 'color' })} />
                <MDBBtn className='btn-colores-opciones' color="pink" onClick={(e) => handleEstilosComponente({ type, id, valor: "pink", nombre: 'color' })} />
                <MDBBtn className='btn-colores-opciones' color="purple" onClick={(e) => handleEstilosComponente({ type, id, valor: "purple", nombre: 'color' })} />
                <MDBBtn className='btn-colores-opciones' color="deep-purple" onClick={(e) => handleEstilosComponente({ type, id, valor: "deep-purple", nombre: 'color' })} />
                <MDBBtn className='btn-colores-opciones' color="indigo" onClick={(e) => handleEstilosComponente({ type, id, valor: "indigo", nombre: 'color' })} />
                <MDBBtn className='btn-colores-opciones' color="light-blue" onClick={(e) => handleEstilosComponente({ type, id, valor: "light-blue", nombre: 'color' })} />
                <MDBBtn className='btn-colores-opciones' color="cyan" onClick={(e) => handleEstilosComponente({ type, id, valor: "cyan", nombre: 'color' })} />
                <MDBBtn className='btn-colores-opciones' color="dark-green" onClick={(e) => handleEstilosComponente({ type, id, valor: "dark-green", nombre: 'color' })} />
                <MDBBtn className='btn-colores-opciones' color="light-green" onClick={(e) => handleEstilosComponente({ type, id, valor: "light-green", nombre: 'color' })} />
                <MDBBtn className='btn-colores-opciones' color="yellow" onClick={(e) => handleEstilosComponente({ type, id, valor: "yellow", nombre: 'color' })} />
                <MDBBtn className='btn-colores-opciones' color="amber" onClick={(e) => handleEstilosComponente({ type, id, valor: "amber", nombre: 'color' })} />
                <MDBBtn className='btn-colores-opciones' color="deep-orange" onClick={(e) => handleEstilosComponente({ type, id, valor: "deep-orange", nombre: 'color' })} />
                <MDBBtn className='btn-colores-opciones' color="brown" onClick={(e) => handleEstilosComponente({ type, id, valor: "brown", nombre: 'color' })} />
                <MDBBtn className='btn-colores-opciones' color="blue-grey" onClick={(e) => handleEstilosComponente({ type, id, valor: "blue-gre", nombre: 'color' })} />
                <MDBBtn className='btn-colores-opciones' color="mdb-color" onClick={(e) => handleEstilosComponente({ type, id, valor: "mdb-color", nombre: 'color' })} />
                <MDBBtn className='btn-colores-opciones' color="white" onClick={(e) => handleEstilosComponente({ type, id, valor: "white", nombre: 'color' })} />
            </div>

            <div className='mb-2'>
                <h6>Texto</h6>
                <input
                    defaultValue={styles?.textoBoton}
                    type="text"
                    className="form-control form-control-sm"
                    onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'textoBoton' })}
                />
            </div>

            <MDBRow className='mb-2'>
                <MDBCol>
                    <h6>Sombra</h6>
                    <input
                        defaultValue={styles?.shadowsBtn}
                        type="number"
                        placeholder='1 a 5'
                        min={0}
                        max={5}
                        className="form-control form-control-sm"
                        onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'shadowsBtn' })}
                    />
                </MDBCol>
                <MDBCol>
                    <h6>Hipervinculo</h6>
                    <input
                        defaultValue={styles?.hipervinculo}
                        type="text"
                        className="form-control form-control-sm"
                        onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'hipervinculo' })}
                    />
                </MDBCol>
            </MDBRow>


            <div className='mb-2'>
                <h6>Tamaño</h6>
                <div className='d-flex'>
                    <div className="custom-control custom-checkbox" onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.checked && 'sm', nombre: 'size' })}>
                        <input type="checkbox" defaultChecked={styles.size == 'sm'} className="custom-control-input" id="pequeno" />
                        <label className="custom-control-label" htmlFor="pequeno">Pequeño</label>
                    </div>

                    <div className="custom-control custom-checkbox ml-3" onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.checked && 'lg', nombre: 'size' })}>
                        <input type="checkbox" className="custom-control-input" id="grande" defaultChecked={styles.size == 'lg'} />
                        <label className="custom-control-label" htmlFor="grande">Grande</label>
                    </div>
                </div>


            </div>

            <div className='d-flex'>
                <div className="custom-control custom-checkbox" onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.checked, nombre: 'outline' })}>
                    <input type="checkbox" className="custom-control-input" id="outline" defaultChecked={styles.outline} />
                    <label className="custom-control-label" htmlFor="outline">Outline</label>
                </div>

                <div className="custom-control custom-checkbox ml-3" onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.checked, nombre: 'rounded' })}>
                    <input type="checkbox" className="custom-control-input" id="rounded" defaultChecked={styles.rounded} />
                    <label className="custom-control-label" htmlFor="rounded">Redondeado</label>
                </div>

                <div className="custom-control custom-checkbox ml-3" onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.checked, nombre: 'hoverBtn' })}>
                    <input type="checkbox" className="custom-control-input" id="hoverBtn" defaultChecked={styles.hoverBtn} />
                    <label className="custom-control-label" htmlFor="hoverBtn">Hover</label>
                </div>
            </div>

        </>
    )
}

export default OpcionesBoton